import { RadioItem as IdskRadioItem } from '@mc-ui/idsk-react-components';

import { withReactHookFormCheckable } from '../hoc/withReactHookFormCheckable';

export const RadioItem = withReactHookFormCheckable(IdskRadioItem);
